import { useNavigate } from "react-router-dom";

import landingBanner from "../assets/png/mountain-banking-landing-banner.png";
import landingBackground from "../assets/png/landing-background.png";

import investWiselyImage from "../assets/jpg/invest-wisely-image.jpg";
import lifeInsuranceImage from "../assets/jpg/life-insurance-image.jpg";
import studentLoanImage from "../assets/jpg/student-loan-image.jpg";

import { ButtonDark, InputWrapper } from "../StyledComponents/AppStyles";
import {
  LandingContainer,
  LandingBackgroundImage,
  LandingBanner,
  LandingBackground,
  FirstRow,
  SecondRow,
  SecondRowContent,
  ThirdRow,
  ThirdRowFirst,
  ThirdRowSecond,
  ThirdRowSecondOptions,
  AutoLoansIcon,
  HomeLoansIcon,
  InvestmentsIcon,
  PersonalLoansIcon,
  OnlineBankingIcon,
} from "../StyledComponents/LandingStyles";

export default function LandingPage() {
  const navigate = useNavigate();

  const handleSubmit = (e) => {
    e.preventDefault();
    alert("Password login is not available in this demo.");
  };

  return (
    <LandingContainer>
      <LandingBackgroundImage
        src={landingBackground}
        alt="landing background"
      />
      <FirstRow>
        <p>
          Welcome to the Indicio Banking Demo. This is a mock website designed
          to show the process of creating an account and logging in with a
          verifiable credential. <br /> Select{" "}
          <u onClick={() => navigate("/login/credentials")}>
            Log in with a credential
          </u>{" "}
          in the Account Log in box below to begin the workflow.
        </p>
      </FirstRow>
      <SecondRow>
        <div>
          <LandingBanner src={landingBanner} alt="mountain banking banner" />
          <SecondRowContent onSubmit={handleSubmit}>
            <h2>Account Log In</h2>
            <InputWrapper>
              <label htmlFor="userID">User ID</label>
              <input type="text" id="user-id" name="userID" />
            </InputWrapper>
            <InputWrapper>
              <label htmlFor="password">Password</label>
              <input type="password" id="password" name="password" />
            </InputWrapper>
            <div>
              <span>
                <input type="checkbox" id="remember" name="remember" />
                <label htmlFor="remember">Remember me</label>
              </span>
              <ButtonDark type="submit">Log in</ButtonDark>
            </div>
            <div>
              <u onClick={() => navigate("/create-account")}>
                Create an account
              </u>
              <u onClick={() => navigate("/login/credentials")}>
                Log in with a credential
              </u>
            </div>
          </SecondRowContent>
        </div>
      </SecondRow>
      <ThirdRow>
        <LandingBackground>
          <span></span>
          <span></span>
        </LandingBackground>
        <ThirdRowFirst>
          <p>How can we help you today?</p>
          <div>
            <div>
              <OnlineBankingIcon />
              <p>Online Banking</p>
            </div>
            <div>
              <InvestmentsIcon />
              <p>Investments</p>
            </div>
            <div>
              <PersonalLoansIcon />
              <p>Personal Loans</p>
            </div>
            <div>
              <HomeLoansIcon />
              <p>Home Loans</p>
            </div>
            <div>
              <AutoLoansIcon />
              <p>Auto Loans</p>
            </div>
          </div>
        </ThirdRowFirst>
        <ThirdRowSecond>
          <p>Financial Guidance and Resources</p>
          <ThirdRowSecondOptions>
            <div>
              <div>
                <img src={investWiselyImage} alt="invest wisely" />
                <div>
                  <p>How to invest wisely and make your money work for you</p>
                  <button>Get started</button>
                </div>
              </div>
            </div>
            <div>
              <div>
                <img src={studentLoanImage} alt="student loans" />
                <div>
                  <p>
                    7 expert tips to make the most out of your student loans
                  </p>
                  <button>See tips</button>
                </div>
              </div>
            </div>
            <div>
              <div>
                <img src={lifeInsuranceImage} alt="life insurance" />
                <div>
                  <p>
                    Which life insurance policy is best for you and your family?
                  </p>
                  <button>Learn more</button>
                </div>
              </div>
            </div>
          </ThirdRowSecondOptions>
        </ThirdRowSecond>
      </ThirdRow>
    </LandingContainer>
  );
}
